import { colors } from '../../styles/colors';

const inputStyle = {
  padding: '0.75rem',
  border: `1px solid ${colors.secondary.lightGray}`,
  borderRadius: '0.5rem',
  fontSize: '1rem',
  fontFamily: '"Noto Sans", sans-serif',
  backgroundColor: colors.text.white,
};

function UsersFilters({ searchTerm, onSearchChange, filterRole, onRoleChange, filterActif, onActifChange }) {
  return (
    <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap', alignItems: 'center' }}>
      <input
        type="text"
        placeholder="Rechercher..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        style={{ ...inputStyle, flex: '1', minWidth: '250px' }}
      />

      <select
        value={filterRole}
        onChange={(e) => onRoleChange(e.target.value)}
        style={{ ...inputStyle, cursor: 'pointer' }}
      >
        <option value="all">Tous les rôles</option>
        <option value="super_admin">Super Admin</option>
        <option value="consultant">Consultant</option>
        <option value="visiteur">Visiteur</option>
      </select>

      <select
        value={filterActif}
        onChange={(e) => onActifChange(e.target.value)}
        style={{ ...inputStyle, cursor: 'pointer' }}
      >
        <option value="all">Tous les statuts</option>
        <option value="actif">Actifs</option>
        <option value="inactif">Inactifs</option>
      </select>
    </div>
  );
}

export default UsersFilters;
